import { NoddiAsyncError } from 'noddi-types';
import { ErrorPageBase, commonTexts, getAdminErrorMessage, useCaptureSentryException } from 'noddi-ui-web';
type ErrorPageInternalProps = {
  apiError: NoddiAsyncError | (NoddiAsyncError | null)[];
};

export const ErrorPageAdmin = ({ apiError }: ErrorPageInternalProps) => {
  useCaptureSentryException(apiError);

  const { title, tryAgain } = commonTexts.errors;

  const descriptionError = getAdminErrorMessage(apiError);

  return (
    <ErrorPageBase
      title={title}
      description={descriptionError}
      buttonText={tryAgain}
      onButtonClick={() => window.location.reload()}
    />
  );
};
